var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "b-tooltip",
        {
          staticClass: "app-button-add-ciec",
          attrs: {
            type: "is-eucalyptus",
            label: _vm.message,
            multilined: "",
            always: ""
          }
        },
        [
          _c(
            "router-link",
            { attrs: { to: _vm.to } },
            [
              _c("b-button", {
                attrs: {
                  size: "is-medium",
                  type: "is-eucalyptus",
                  "icon-left": "archive"
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }